// Arabic Meyar product pages: Enterprise GRC + Cyber Security GRC. Both
// use the shared ArInnerPage renderer so section styling matches the rest
// of the /ar/* catalogue.
import { ArInnerPage } from "@/pages/ar/_ArInnerPage";

const ENTERPRISE_GRC_AR = {
  eyebrow: "Meyar",
  h1: "Meyar Enterprise GRC",
  meta: {
    title: "Meyar Enterprise GRC — الحوكمة والمخاطر مترابطتان",
    description: "سجل مخاطر المؤسسة، الضوابط، السياسات، والامتثال — مترابطة، موثقة، وجاهزة لمجلس الإدارة.",
  },
  intro: "كل مؤسسة تحمل مخاطر لم تُدوَّن أبدًا — التركّز في مورد واحد، العملية التي يفهمها شخص واحد فقط، الالتزام التنظيمي الذي لم يعد أحد يملكه منذ رحل من كان يفهمه. حوكمة المؤسسات هي ضبط ما هي هذه المخاطر، من يملكها، وهل يُفعل شيء حيالها فعليًا.",
  sections: [
    {
      type: "grid", heading: "ما تغطيه",
      items: [
        { title: "سجل مخاطر المؤسسة", desc: "تقييم أصلي وتقييم متبقٍّ، مع سجل تغييرات كامل." },
        { title: "الضوابط واختبارها", desc: "الضابط، الملكية، تكرار الاختبار، ونتائج آخر اختبار — كلها في مكان واحد." },
        { title: "إدارة السياسات", desc: "التحكم بالإصدارات، الإقرارات، وتذكيرات المراجعة." },
        { title: "الالتزامات التنظيمية", desc: "بما فيها قانون حماية البيانات — كل مادة موزّعة على ضابط أو دليل." },
        { title: "مخاطر الأطراف الثالثة والموردين", desc: "استبيانات، مراجعات، وتنبيهات انتهاء الصلاحية." },
        { title: "إدارة التدقيق", desc: "جدول الاختبارات، تعقب النتائج، والمعالجة." },
        { title: "سجل الحوادث", desc: "التسجيل، التصنيف، المسار، والدروس المستفادة." },
        { title: "تقارير مجلس الإدارة", desc: "بضغطة زر، بالعربية والإنجليزية، جاهزة للتقديم." },
      ],
    },
    {
      type: "grid", heading: "لمن",
      items: [
        { title: "كبير مسؤولي المخاطر", desc: "الصورة الشاملة، والقدرة على الغوص في أي بند." },
        { title: "رئيس الامتثال", desc: "الالتزامات، الأدلة، والاستعداد للتدقيق." },
        { title: "التدقيق الداخلي", desc: "الجدول، الأدلة، والمتابعة." },
        { title: "أمين الشركة", desc: "الحوكمة، المستندات، وتقارير المجلس." },
        { title: "المدير المالي", desc: "المخاطر التشغيلية والمالية على نفس الرادار." },
      ],
    },
    { type: "callout", text: "مُحمّل مسبقًا بمكتبة مخاطر مؤسسية، ومكتبة ضوابط قابلة للتخصيص، وقواعد الالتزامات التنظيمية العُمانية." },
  ],
  related: [
    { tag: "Meyar", label: "Meyar — نظرة عامة", to: "/ar/meyar" },
    { tag: "Meyar", label: "Meyar Cyber Security GRC", to: "/ar/meyar/cyber-security-grc" },
    { tag: "الخدمات", label: "الحوسبة السحابية وإقامة البيانات", to: "/ar/services/cloud-devops-oman" },
  ],
};

const CYBER_SECURITY_GRC_AR = {
  eyebrow: "Meyar",
  h1: "Meyar Cyber Security GRC",
  meta: {
    title: "Meyar Cyber Security GRC — نظام السجل لحوكمة الأمن",
    description: "إطار الضوابط، سجل مخاطر الأمن، بيان الانطباق، الحوادث، والأدلة — كلها في مكان واحد.",
  },
  intro: "أدواتكم الأمنية تخبركم بما يحدث الآن. حوكمة الأمن تجيب عن سؤال مختلف — أي ضوابط تدّعون امتلاكها، هل هي حقيقية، متى اختُبرت آخر مرة، وهل يمكنكم إثبات أي من ذلك؟",
  sections: [
    {
      type: "block", heading: "ما هي وما ليست عليه",
      paragraphs: [
        "Meyar Cyber Security GRC هي نظام السجل لحوكمة أمن المعلومات — إطار الضوابط، سجل مخاطر الأمن، نتائج اختبار الضوابط، الحوادث الأمنية، والأدلة وراء كل ذلك.",
        "هي ليست أداة مراقبة، منصة تنبيهات، أو مركز عمليات أمنية. لا تفحص شبكتكم ولا تحظر أي شيء. إنها تحكم الإطار الذي تعمل ضمنه أدواتكم الأمنية.",
      ],
    },
    {
      type: "grid", heading: "ما تغطيه",
      items: [
        { title: "إطار ضوابط أمنية", desc: "ISO 27001، NIST CSF، PCI DSS، SOC 2، أو إطاركم الخاص." },
        { title: "ربط متعدد الأطر", desc: "ضابط واحد يُعرَّف مرة، يُستخدم عبر أطر عدة." },
        { title: "سجل مخاطر أمنية", desc: "تقييم، معالجة، وسجل تغييرات كامل." },
        { title: "بيان الانطباق", desc: "يُنشأ ويُحدَّث تلقائيًا مع تغيّر الضوابط." },
        { title: "اختبار الضوابط مع الأدلة", desc: "كل اختبار موقّت، موقّع، ومربوط بالدليل." },
        { title: "سجل حوادث وخروقات", desc: "ضمن مسار الـ72 ساعة لقانون حماية البيانات." },
        { title: "استبيانات مخاطر الموردين", desc: "قوالب، إرسال، تتبع، وتحليل." },
        { title: "السياسات والإقرارات", desc: "من قرأ، ومتى، وعلى أي نسخة." },
        { title: "لوحات معلومات أمنية", desc: "لكبير مسؤولي أمن المعلومات، للمجلس، وللمدقق." },
      ],
    },
    {
      type: "block", heading: "\"هل تقدّمون خدمات أمن سيبراني أيضًا؟\"",
      paragraphs: [
        "لا. Meyar منصة حوكمة. نُهيّئها، نُحمّل إطاركم، ونُدرّب فريقكم — لا نُشغّل عمليات أمنية، اختبار اختراق، أو استجابة للحوادث.",
      ],
    },
  ],
  related: [
    { tag: "Meyar", label: "Meyar — نظرة عامة", to: "/ar/meyar" },
    { tag: "Meyar", label: "Meyar Enterprise GRC", to: "/ar/meyar/enterprise-grc" },
    { tag: "الخدمات", label: "دعم وصيانة التطبيقات", to: "/ar/services/application-support-maintenance-oman" },
  ],
};

export function MeyarEnterpriseGrcAr() {
  return (
    <ArInnerPage
      {...ENTERPRISE_GRC_AR}
      breadcrumbs={[{ label: "الرئيسية", to: "/ar" }, { label: "Meyar", to: "/ar/meyar" }, { label: "Enterprise GRC" }]}
    />
  );
}

export function MeyarCyberSecurityGrcAr() {
  return (
    <ArInnerPage
      {...CYBER_SECURITY_GRC_AR}
      breadcrumbs={[{ label: "الرئيسية", to: "/ar" }, { label: "Meyar", to: "/ar/meyar" }, { label: "Cyber Security GRC" }]}
    />
  );
}
